import { isFunction } from "@suse-o11y/is-function";

export type Setter<TValue, TArgs extends ReadonlyArray<unknown> = [TValue]> = TValue | ((...args: TArgs) => TValue);

export function resolve<TValue, TArgs extends ReadonlyArray<unknown> = [TValue]>(
	value: Setter<TValue, TArgs>,
	...args: TArgs
): TValue {
	return isFunction(value) ? value(...args) : value;
}
